import styled, { css } from 'styled-components'
import posed from 'react-pose'

export const StyledTitle = styled.div`
    font-size: 14px;
    letter-spacing: 0.44px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    transition: color 0.3s;
`

export const StyledIcon = styled.div`
    position: relative;
    width: 15px;
    height: 15px;
    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 100%;
        border-right: 2px solid ${({ theme }) => theme.brownGrey};
        border-bottom: 2px solid ${({ theme }) => theme.brownGrey};
        transform: rotate(45deg);
        transition: border 0.5s;
        margin-top: -14.5px;
        transition: opacity 0.3s;
    }
    &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 100%;
        border-top: 2px solid ${({ theme }) => theme.grassyGreen};
        border-left: 2px solid ${({ theme }) => theme.grassyGreen};
        transform: rotate(45deg);
        transition: border 0.5s;
        margin-top: -3.5px;
        opacity: 0;
        transition: opacity 0.3s;
    }
`

export const StyledExpansionPanelSummary = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    ${StyledTitle} {
        color: ${({ isOpen, theme }) => (isOpen ? theme.grassyGreen : theme.greyishBrown)};
    }
    ${StyledIcon} {
        ${({ isOpen }) =>
        isOpen &&
        css`
            &:before {
                opacity: 0;
            }
            &:after {
                opacity: 1;
            }
        `};
    }
`

export const StyledExpansionPanelDetails = styled.div`
    padding-top: 30px;
`

const StyledExpansionPanelDetailsWrapperPosed = posed.div({
    enter: {
        height: '100%'
    },
    exit: {
        height: '0%',
    }
});

export const StyledExpansionPanelDetailsWrapper = styled(StyledExpansionPanelDetailsWrapperPosed)`
    background-color: ${({ theme }) => theme.whiteTwo};
    overflow: hidden;
`

export const StyledExpansionPanel = styled.div`
    position: relative;
    background-color: ${({ theme }) => theme.whiteTwo};
`